const PlaceholderSearchBar = () => {
    return (
        <div className="d-flex justify-content-center mt-5 position-relative mb-5 mx-auto"
            style={{
                width: '1130px'
            }}
        >
            <div className="bg-primary-blue rounded-4 p-4 w-100">
                <div className="placeholder-glow"> {/* Added for animation */}
                    <h2 className="fs-2 text-white mb-3 text-center">
                        <div className="placeholder-text" style={{ height: '30px', width: '50%', backgroundColor: '#e0e0e0', margin: '0 auto', opacity: '0.7' }}></div>
                    </h2>

                    <div className="row g-3 align-items-center w-full">
                        <div className="col-md-4">
                            <div className="placeholder-text" style={{ height: '38px', backgroundColor: '#e0e0e0', opacity: '0.7' }}></div>
                        </div>
                        <div className="col-md-8">
                            <div className="input-group">
                                <div className="placeholder-text form-control" style={{ height: '38px', backgroundColor: '#e0e0e0', opacity: '0.05' }}></div>
                                <div className="btn bg-search placeholder-text" style={{ height: '38px', width: '50px', backgroundColor: '#e0e0e0', opacity: '0.7' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlaceholderSearchBar;
